import * as React from 'react';
import { Page as PortalUXPage } from '@uifabric/portal-ux/lib/Page';
import { useTheme as useTwouiTheme } from '@amx/ux-twoui-theming';
import { IRawStyle } from '@fluentui/react';
import { IStyles } from '@uifabric/portal-ux/lib/styling/stylingTypes';
import { Spinner } from '@amx/ux-twoui';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';
import { ErrorBoundary } from '@uifabric/portal-ux/lib/ErrorBoundary';
import { ErrorPage } from '../ErrorPage';

export interface IPageProps {
  styles: { root?: IRawStyle; content?: IStyles };
  automationId: string;
}

export const Page: React.FunctionComponent<IPageProps> = ({ styles, automationId, children }) => {
  const twouiTheme = useTwouiTheme();

  return (
    <PortalUXPage
      automationId={automationId}
      styles={{
        root: { ...styles.root, backgroundColor: twouiTheme.semanticColors.bodyBackground },
        content: styles.content,
      }}
    >
      {children}
    </PortalUXPage>
  );
};

export const ErrorBoundaryPage: React.FC = ({ children }) => {
  const [t] = useLocalization(['Account']);
  return (
    <ErrorBoundary component={ErrorPage}>
      <React.Suspense fallback={<Spinner aria-label={t('loading')} label={t('loading')} spinnerSize={3} />}>
        {children}
      </React.Suspense>
    </ErrorBoundary>
  );
};
